<template>
  <div id="app">
    <div class="wrap" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />

      <div class="intro">
        <div class="glassmorphism" v-if="!darkModeYn"></div>
        <div id="idleScheduleArea" v-if="!darkModeYn && useIdleScreen" class="scheduleArea" @mouseup="bgIdleChange()"></div>

        <div class="intro__body">
          <div class="intro__ad">
            <div id="brnadScheduleArea" class="scheduleArea" style="width: 100%; height: 100%"></div>

            <!-- <span class="ft--3xlg b-logo" v-if="brandLogo == null || brandLogo.DISP_KIND_CD == 'T'">Brand logo</span> -->
            <img :src="brandLogo.FILE_URL" v-if="brandLogo != null && brandLogo.DISP_KIND_CD == 'I'" alt="" class="b-logo" style="width: 100%; height: 100%" />
          </div>
          <div class="intro__order">
            <div class="intro__welcome">
              <span v-if="dispText != null">
                {{ dispText.replaceAll('^', '\n') }}
              </span>
            </div>
            <div class="intro__btns">
              <!-- 버튼 하나  btn-intro--lg, 버튼 둘 btn-intro--md, 버튼 셋 btn-intro--sm -->
              <button
                v-if="(idleScreenOrderType == '01' || idleScreenOrderType == '03') && this.$store.getters.getSettingType != '3'"
                :class="idleScreenOrderType == '03' ? 'btn-intro--md' : 'btn-intro--lg'"
                class="btn-intro btn--shadow btn--color btn-anim"
                @mouseup="
                  $router.push('/user/order');
                  $store.dispatch('setOrderType', 1);
                  $logInfo('Order Click Eat In');
                "
              >
                <span class="txt">{{ $t('User.Idle.msg2') }}</span>
                <IconGo class="ico-go" />
              </button>
              <button
                v-if="(idleScreenOrderType == '02' || idleScreenOrderType == '03') && this.$store.getters.getSettingType != '3'"
                :class="idleScreenOrderType == '03' ? 'btn-intro--md' : 'btn-intro--lg'"
                class="btn-intro btn--shadow btn--color btn-anim"
                @mouseup="
                  $router.push('/user/order');
                  $store.dispatch('setOrderType', 2);
                  $logInfo('Order Click Takeout');
                "
              >
                <span class="txt">{{ $t('User.Idle.msg3') }}</span>
                <IconGo class="ico-go" />
              </button>
              <button
                v-if="idleScreenOrderType == '00' && this.$store.getters.getSettingType != '3'"
                class="btn-intro btn--shadow btn--color btn-anim btn-intro--lg"
                @mouseup="
                  $router.push('/user/order');
                  $store.dispatch('setOrderType', 3);
                  $logInfo('Order Click Start');
                "
              >
                <span class="txt">시작하기</span>
                <IconGo class="ico-go" />
              </button>

              <button
                v-if="this.$store.getters.getSettingType == '3'"
                :class="idleScreenOrderType == '03' ? 'btn-intro--md' : 'btn-intro--lg'"
                class="btn-intro btn--shadow btn--color btn-anim"
                @mouseup="
                  $router.push('/user/order');
                  $store.dispatch('setOrderType', 2);
                  $logInfo('Order Click Takeout');
                "
              >
                <span class="txt">{{ $t('User.Idle.msg14') }}</span>
                <IconGo class="ico-go" />
              </button>
            </div>
          </div>
          <div class="intro__lang">
            <div class="txt-info">
              <i class="ico-lang"></i>
              <span>{{ $t('User.Idle.msg5') }}</span>
            </div>
            <div class="intro__slctlang">
              <div
                class="lang-item"
                :class="{on: defaultLanguage == 'CH' ? $i18n.locale == 'cn' : $i18n.locale == defaultLanguage.toLowerCase()}"
                @mouseup="
                  [(locales = defaultLanguage == 'CH' ? 'cn' : defaultLanguage.toLowerCase()), ($i18n.locale = locales)];
                  $logInfo(`Locale Change : ${defaultLanguage}`);
                "
              >
                <span v-if="defaultLanguage == 'JP'">{{ $t('User.Idle.msg6') }}</span>
                <span v-if="defaultLanguage == 'KO'">{{ $t('User.Idle.msg7') }}</span>
                <span v-if="defaultLanguage == 'EN'">{{ $t('User.Idle.msg8') }}</span>
                <span v-if="defaultLanguage == 'CH'">{{ $t('User.Idle.msg9') }}</span>
                <span v-if="defaultLanguage == 'TW'">{{ $t('User.Idle.msg10') }}</span>
              </div>
              <div
                v-for="locale in supportLocale.filter((loc) => loc != defaultLanguage)"
                :key="locale"
                class="lang-item"
                :class="{on: locale == 'CH' ? $i18n.locale == 'cn' : $i18n.locale == locale.toLowerCase()}"
                @mouseup="
                  [(locales = locale == 'CH' ? 'cn' : locale.toLowerCase()), ($i18n.locale = locales)];
                  $logInfo(`Locale Change : ${locale}`);
                "
              >
                <span v-if="locale == 'JP'">{{ $t('User.Idle.msg6') }}</span>
                <span v-if="locale == 'KO'">{{ $t('User.Idle.msg7') }}</span>
                <span v-if="locale == 'EN'">{{ $t('User.Idle.msg8') }}</span>
                <span v-if="locale == 'CH'">{{ $t('User.Idle.msg9') }}</span>
                <span v-if="locale == 'TW'">{{ $t('User.Idle.msg10') }}</span>
              </div>
            </div>
          </div>
          <div class="intro__bottom-btns">
            <!--4-->
            <button v-if="idleScreenExtrasType.split('')[0] == 1" class="btn btn--square btn--lgray btn-anim" @mouseup="$emit('emReady')">
              <i class="ico-emoney ico-sm"></i>{{ $t('User.Idle.msg11') }}
            </button>
            <!--1-->
            <button v-if="idleScreenExtrasType.split('')[2] == 1" class="btn btn--square btn--lgray btn-anim" @mouseup="$emit('staffCall')">
              <i class="ico-staff ico-sm"></i>{{ $t('User.Idle.msg12') }}
            </button>
            <!--2-->
            <button v-if="idleScreenExtrasType.split('')[1] == 1" class="btn btn--square btn--lgray btn-anim" @mouseup="$emit('helper')">
              <i class="ico-helper ico-sm"></i>{{ $t('User.Idle.msg13') }}
            </button>
            <!-- <button class="btn btn--square btn--lgray"><img src="../../assets/images/user/ico-helper.svg" class="ico-intro-btn">장애인<br>도움기능</button>
          <button class="btn btn--square btn--lgray"><img src="../../assets/images/user/ico-helper.svg" class="ico-intro-btn">장애인<br>도움기능</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helperHeight from '@/components/common/HelperHeight.vue';
import SchedulerHelper from '@/js/common/schedulerHelper.js';

import IconGo from '@/components/common/IconGo.vue';

let idleScheduler = null;
let brandScheduler = null;
export default {
  name: 'idle3',
  methods: {},
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      locales: this.$i18n.locale,
      custDisp: this.$store.getters.getMasterData.TB_MST_CUST_DISP,
      adSrc: '',
      adType: '',
      adNum: 0,
      //brandLogo: this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.POS_GBN_CD == '07')[0], //메인 브랜드 로고
      //brandAds: this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.POS_GBN_CD == '08'), // 메인 광고
      //mainScreen: this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.POS_GBN_CD == '03'), // 대기화면
      dispTextArr:
        this.$store.getters.getMasterData.TB_MST_CUST_DISP == null
          ? null
          : this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '04'),
      msSrc: '',
      msType: '',
      msNum: 0,
      mst: null,
      //지원 가능 언어
      supportLocale: this.$store.getters.getPosConfig.posConfig.supportLanguages,
      defaultLanguage: this.$store.getters.getPosConfig.posConfig.defaultLanguage,
      //대기화면 유무
      useIdleScreen: this.$store.getters.getPosConfig.posConfig.useIdleScreen,
      //대기화면 부가 기능 버튼
      idleScreenExtrasType: parseInt(this.$store.getters.getPosConfig.posConfig.idleScreenExtrasType).toString(2).padStart(3, '0'),
      nowDate: new Date().getHours() + '' + (new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()),
      //주문 방법 선택 여부
      idleScreenOrderType: this.$store.getters.getPosConfig.posConfig.idleScreenOrderType,
    };
  },
  mounted() {
    var currentUrl = window.location.pathname;
    console.log(`Current URL => ${currentUrl}`);

    let that = this;
    idleScheduler = new SchedulerHelper({
      tag: 'IDLE',
      targetId: 'idleScheduleArea',
      imageClass: 'intro__bg',
      videoClass: 'intro__bg',
      currentUrl: currentUrl,
      scheduleData: that.mainScreen,
    });
    idleScheduler.startSchedule();

    brandScheduler = new SchedulerHelper({
      tag: 'BRAND',
      targetId: 'brnadScheduleArea',
      imageClass: 'intro__adimg',
      videoClass: 'intro__adimg',
      currentUrl: currentUrl,
      scheduleData: that.brandAds,
    });

    this.$showButtonAnimation();

    this.$log.info('IDLE', 'Enter IDLE 3 page');
  },
  created() {},
  beforeCreate() {},
  components: {
    HelperHeight: helperHeight,
    IconGo: IconGo,
  },
  methods: {
    bgIdleChange() {
      idleScheduler.dimmedSchedule();
      idleScheduler.timeoutSchedule();
      brandScheduler.startSchedule();
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
    dispText() {
      const date = new Date();
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      // 메인 로고 텍스트
      if (this.dispTextArr == null) return null;
      let textArr = this.dispTextArr.filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
      if (textArr && textArr.length > 0) {
        if (this.$i18n.locale == 'jp') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_JP;
          });
        } else if (this.$i18n.locale == 'ko') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_KO;
          });
        } else if (this.$i18n.locale == 'en') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_EN;
          });
        } else if (this.$i18n.locale == 'cn') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_CN;
          });
        } else if (this.$i18n.locale == 'tw') {
          textArr.forEach((item) => {
            item.DISP_TEXT = item.DISP_TEXT_TW;
          });
        }

        return textArr[0].DISP_TEXT;
      } else {
        return '';
      }
    },
    brandLogo() {
      const date = new Date();
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '02').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      )[0];
    },
    mainScreen() {
      const date = new Date();
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '01').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
    },
    brandAds() {
      const date = new Date();
      if (this.$store.getters.getMasterData.TB_MST_CUST_DISP == null) return null;
      //let now = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + '' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      return this.$store.getters.getMasterData.TB_MST_CUST_DISP.filter((item) => item.DISP_AREA == '03').filter(
        (item) => this.$strToDate(item.FROM_TIME, item.END_TIME, 0) <= date < this.$strToDate(item.FROM_TIME, item.END_TIME, 1)
      );
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    '$i18n.locale'(val) {
      window.parent.postMessage(val, '*');
      this.$store.dispatch('setLocale', this.$i18n.locale);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/intro.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/intro-dark.css" scoped></style>
<style scoped>
.scheduleArea {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>

<style>
.intro__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.scheduleArea img,
.scheduleArea video {
  width: 100%;
  height: 100%;
}

.intro__lang {
  display: -webkit-inline-box;
}
</style>
